




import { Component } from 'vue-property-decorator';
import IconMixin from '@/components/Helper/Icon/icon.mixin';
import SvgIcon from '@/components/Helper/Icon/SvgIcon.vue';

@Component<CheckedIcon>({
  components: { SvgIcon },
})
export default class CheckedIcon extends IconMixin {
  paths: string[] = [
    'M208.705,42.004L73.401,177.307L0,103.908l10.607-10.606l62.794,62.793L198.098,31.398L208.705,42.004z',
  ];
}
